import * as _ from "lodash";
import { Button, Grid, MenuItem, Typography } from "@mui/material";
import { Fragment, useEffect, useRef, useState } from "react";

import { TextField } from "../../../../components";
import { useAxios } from "../../../../hooks";
import { useSelector } from "react-redux";

export default function Webhook({ formikProps, editState, fields }) {
  const axios = useAxios();
  const inputRef = useRef(null);

  const [message, setMessage] = useState({});
  const [cursorPos, setCursorPos] = useState(0);
  const [resources, setReources] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [previousChar, setPreviousChar] = useState("");
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });

  const { ID } = useSelector((state) => state.memberDetails.activeBot);

  useEffect(() => {
    axios({
      url: "/resources/" + ID,
    }).then((response) => {
      if (response.status) {
        setReources(response.data);
      }
    });
  }, [axios, ID]);

  const closePopup = () => {
    setShowPopup(false);
  };

  const handleParseJson = async (name) => {
    let value = _.get(formikProps.values, name);
    try {
      JSON.parse(value);
      setMessage({ ...message, [name]: "" });

      const parsedJson = JSON.parse(value);
      const formattedJson = JSON.stringify(parsedJson, null, 2);

      await formikProps.setValues((prev) => ({
        ...prev,
        [name]: formattedJson,
      }));
    } catch (e) {
      // Catch and handle JSON parsing errors
      if (e instanceof SyntaxError) {
        setMessage({
          ...message,
          [name]: "Invalid JSON format! Please check the syntax.",
        });
      } else {
        setMessage({
          ...message,
          [name]: "An unknown error occurred.",
        });
      }

      return;
    }
  };

  function handleEnterCustomField(textToInsert) {
    const beforeCursor = formikProps.values.sample_payload.slice(
      0,
      cursorPos - 3
    );
    const afterCursor = formikProps.values.sample_payload.slice(cursorPos);
    const newText = beforeCursor + `"{{${textToInsert}}}"` + afterCursor;
    formikProps.setValues((prev) => ({
      ...prev,
      sample_payload: newText,
    }));
    setPreviousChar("");
    setCursorPos(beforeCursor.length + textToInsert.length);
    setShowPopup(false);
  }

  return (
    <Fragment>
      <Grid item xs={12}>
        <Typography variant="h5">Add Webhook Details</Typography>
      </Grid>

      <Grid item xs={4}>
        <TextField
          select
          name="resource"
          label="Select Resource"
          formikProps={formikProps}
          disabled={!editState}
        >
          {resources.map((res) => (
            <MenuItem key={res._id} value={res._id}>
              {res.resource_name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={4}>
        <TextField
          name="url"
          label="Webhook URL"
          formikProps={formikProps}
          disabled={!editState}
        />
      </Grid>

      <Grid item xs={4}>
        <TextField
          select
          name="method"
          label="Webhook Method"
          formikProps={formikProps}
          disabled={!editState}
        >
          <MenuItem value="get">GET</MenuItem>
          <MenuItem value="post">POST</MenuItem>
          <MenuItem value="put">PUT</MenuItem>
          <MenuItem value="patch">PATCH</MenuItem>
          <MenuItem value="delete">DELETE</MenuItem>
          <MenuItem value="options">OPTIONS</MenuItem>
        </TextField>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h5">Headers</Typography>
      </Grid>

      <Grid item xs={8}>
        {formikProps.values?.headers && editState && (
          <Button
            style={{
              float: "right",
              cursor: "pointer",
              padding: "0 4px",
              margin: "4px 0",
            }}
            variant="outlined"
            onClick={() => handleParseJson("headers")}
          >
            {" "}
            Beautify JSON
          </Button>
        )}

        <TextField
          multiline
          name="headers"
          label="Add Authorization"
          formikProps={formikProps}
          disabled={!editState}
        />

        <Typography variant="body1" color="red">
          {message?.["headers"]}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h5">Payload</Typography>
      </Grid>

      <Grid item xs={8}>
        {formikProps.values.sample_payload && editState && (
          <Button
            style={{
              padding: "0 4px",
              margin: "4px 0",
              float: "right",
              cursor: "pointer",
            }}
            variant="outlined"
            onClick={() => handleParseJson("sample_payload")}
          >
            {" "}
            Beautify JSON
          </Button>
        )}

        <TextField
          ref={inputRef}
          label="Sample Payload"
          disabled={!editState}
          value={formikProps.values.sample_payload}
          onChange={(e) => {
            formikProps.setValues((prev) => ({
              ...prev,
              sample_payload: e.target.value,
            }));
          }}
          onKeyDown={(e) => {
            if (e.key === "{") {
              setPreviousChar("{");
              const cursorPosition = e.target.selectionStart + 2; // Get cursor position
              setCursorPos(e.target.selectionStart + 2);
              const rect = e.target.getBoundingClientRect(); // Get input field position
              const x = rect.left + cursorPosition; // 8px per character (approximate width)
              const y = rect.top + rect.height - 200; // Position it just below the input field

              setPopupPosition({ top: y, left: x });
              if (e.key === previousChar) {
                setShowPopup(true);
              }
            }
          }}
          placeholder="Paste your raw JSON here..."
          multiline
        />

        {showPopup && (
          <div
            style={{
              height: "200px",
              position: "absolute",
              top: `${popupPosition.top}px`,
              left: `${popupPosition.left}px`,
              backgroundColor: "white",
              border: "1px solid #ccc",
              padding: "10px",
              borderRadius: "5px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              zIndex: 10,
              overflow: "scroll",
            }}
          >
            <Typography variant="body1">You can choose fields </Typography>
            {fields.map((item) => (
              <Fragment>
                <MenuItem
                  style={{
                    margin: "4px 0",
                    backgroundColor: "white",
                    borderRadius: "8px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    overflow: "hidden",
                    width: "200px",
                    padding: "10px",
                  }}
                  onClick={() => handleEnterCustomField(item.name)}
                  key={item.name}
                  value={item.name}
                >
                  {item.label}
                </MenuItem>
              </Fragment>
            ))}

            <Button
              style={{ padding: "10px", display: "flex" }}
              onClick={closePopup}
              variant="outlined"
            >
              Close
            </Button>
          </div>
        )}

        <Typography variant="body1" color="red">
          {message?.["sample_payload"]}
        </Typography>

        {formikProps.values.sample_payload &&
          !message?.["sample_payload"] &&
          editState && (
            <Typography variant="body1" color="green">
              NOTE: {`Type {{ infront of key to get custom field list `}
            </Typography>
          )}
      </Grid>
    </Fragment>
  );
}
